(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.artistryLandingSocial = {
    attach: function (context) {
      Drupal.behaviors.socialMedia.twitter(context);
    }
  };
})(jQuery, Drupal);
